var exports = {
  "s": "x93eb46d8--78667b--price-container",
};

module.exports = exports;
